import React from 'react';
import { css } from '@emotion/core';

import { colors } from '../../utils/styles';

const svg = css`
  display: flex;
  items-center: center;
  height: 28px;
`;

const monogram = css`
  margin-right: 10px;
`;

const headertext = css`
  font-family: Josefin sans;
  font-size: 1.5rem;
  align-self: flex-end;
  color: ${colors.darkest};
`;

const Monogram = () => (
  <svg viewBox="0 0 142.91 145" css={[svg, monogram]}>
    <g transform="translate(-289.47 -573.21)">
      <path
        transform="matrix(.70742 .36063 -.35896 .88202 360.84 180.29)"
        d="m267.86 425.15c-6.8206-11.259-5.1914-27.436 3.639-36.132 8.8304-8.6963 21.518-6.619 28.339 4.6398 6.8206 11.259 5.1914 27.436-3.639 36.132-8.7683 8.6351-21.355 6.6555-28.215-4.4374"
        fill={colors.brand}
        stroke={colors.brand}
        strokeLinecap="round"
        strokeWidth="1.7"
      />
      <path
        transform="matrix(.87169 .16245 -.18518 .93388 257.44 186.81)"
        d="m214.99 420.94c-7.1838-12.583-5.4678-30.663 3.8328-40.383 9.3006-9.7194 22.664-7.3977 29.848 5.1856 7.1838 12.583 5.4678 30.663-3.8328 40.383-9.2351 9.651-22.492 7.4385-29.717-4.9595"
        fill={colors.brand}
        stroke={colors.brand}
        strokeLinecap="round"
        strokeWidth="1.7"
      />
      <path
        transform="matrix(.67878 -.42554 .29257 .83997 93.872 334.53)"
        d="m208.09 413.44c0 15.9-10.402 28.789-23.234 28.789s-23.234-12.889-23.234-28.789 10.402-28.789 23.234-28.789 23.234 12.889 23.234 28.789z"
        fill={colors.brand}
        stroke={colors.brand}
        strokeLinecap="round"
        strokeWidth="1.7"
      />
      <path
        transform="matrix(.64816 -.38527 .34677 .80376 61.638 303.82)"
        d="m107.67 493.47c-7.5027-12.804-5.7105-31.201 4.0029-41.091 9.7135-9.8899 23.67-7.5275 31.173 5.2766 7.5027 12.804 5.7105 31.201-4.0029 41.091-9.6451 9.8203-23.491 7.569-31.036-5.0465"
        fill={colors.brand}
        stroke={colors.brand}
        strokeLinecap="round"
        strokeWidth="1.7"
      />
      <path
        d="m309.38 679.04c-3.8416 5.2598-3.7533 16.403 0.72761 22.367 10.239 13.627 31.601 15.001 48.627 15.822 18.205 0.87739 41.936 2.3449 53.382-11.84 3.5163-4.3578 2.2729-11.642 0.0895-16.798-3.3376-7.882-12.567-11.636-18.535-17.772-5.2847-5.4336-8.3834-13.689-15.275-16.844-10.07-4.6101-22.746-4.4194-33.217-0.81075-5.4302 1.8714-8.6728 7.5539-13.309 10.944-6.865 5.0188-14.805 8.5149-21.417 13.861-0.39277 0.31755-1.0714 1.0714-1.0714 1.0714z"
        fill={colors.brand}
        stroke={colors.brand}
        strokeWidth=".89702px"
      />
    </g>
  </svg>
);

export default () => (
  <div css={svg}>
    <Monogram />
    <div css={headertext}>Doggyckers</div>
  </div>
);
